const initState = {
  updateAthleteError: null,
  athleteUpdated: false,
  athleteUpdateProgress: null,
  athleteUpdateProgressType: null,
  playerToWatchProgress: null,
  playerToWatchProgressType: null,
  playerToWatchDeleted: false,
  athleteUpdating: false,
  addAthleteError: null,
  athleteAdded: false,
  playerToWatchAdded: false,
  deleteAthleteError: null,
  athleteDeleted: false,
  infoRequestError: null,
  infoRequestSent: false,
  joinCsaRequestError: null,
  joinCsaRequestSent: false,
  contactRequestError: null,
  contactRequestSent: false,
  updateAthleteEventsError: null,
  athleteEventsUpdated: false,
  addSchoolError: null,
  schoolAdded: false,
  editSchoolError: null,
  schoolEdited: false,
  skillAddProgress: null,
  skillAddProgressType: null,
  skillAdding: false,
  skillAddError: null,
  skillAdded: false,
  skillUpdateProgress: null,
  skillUpdateProgressType: null,
  skillUpdateing: false,
  skillUpdateError: null,
  skillUpdated: false,
  addSkillError: false,
  addAdvocateError: false,
  advocateAddProgress: null,
  advocateAddProgressType: null,
  advocateAdding: false,
  advocateAddError: null,
  advocateAdded: false,
  advocateUpdateProgress: null,
  advocateUpdateProgressType: null,
  advocateUpdateing: false,
  advocateUpdateError: null,
  advocateUpdated: false,
  sport: null,
  superSport: null,
  date: null,
  superDate: null,
  creator: null,
  superCreator: null,
};

const athleteReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_SPORT":
      return {
        ...state,
        sport: action.value ? action.value : null,
      };
    case "GET_DATE":
      return {
        ...state,
        date: action.value ? action.value : null,
      };
    case "GET_CREATOR":
      return {
        ...state,
        creator: action.value ? action.value : null,
      };
    case "GET_SuperSPORT":
      return {
        ...state,
        superSport: action.value ? action.value : null,
      };
    case "GET_SuperDATE":
      return {
        ...state,
        superDate: action.value ? action.value : null,
      };
    case "GET_SuperCREATOR":
      return {
        ...state,
        superCreator: action.value ? action.value : null,
      };
    case "UPDATE_ATHLETE_ERROR":
      return {
        ...state,
        updateAthleteError: "Update failed",
        athleteUpdated: false,
      };
    case "UPDATE_ATHLETE_SUCCESS":
      return {
        ...state,
        updateAthleteError: null,
        athleteUpdated: true,
      };
    case "ADD_SKILL_ERROR":
      return {
        ...state,
        addSkillError: "Add failed",
        skillAdded: false,
      };
    case "UPDATE_SKILL_ERROR":
      return {
        ...state,
        updateSkillError: "Update failed",
        skillAdded: false,
      };
    case "UPDATE_SKILL_SUCCESS":
      return {
        ...state,
        addSkillError: false,
        skillAddProgress: null,
        skillAddProgressType: null,
        skillAdded: true,
        skillAdding: false,
      };
    case "ADD_SKILL_SUCCESS":
      return {
        ...state,
        addSkillError: false,
        skillAddProgress: null,
        skillAddProgressType: null,
        skillAdded: true,
        skillAdding: false,
      };
    case "ADD_ADVOCATE_ERROR":
      return {
        ...state,
        addAdvocateError: "Add failed",
        advocateAdded: false,
      };
    case "UPDATE_ADVOCATE_ERROR":
      return {
        ...state,
        updateAdvocateError: "Update failed",
        advocateAdded: false,
      };
    case "UPDATE_ADVOCATE_SUCCESS":
      return {
        ...state,
        addAdvocateError: false,
        advocateUpdateProgress: null,
        advocateUpdateProgressType: null,
        advocateUpdated: true,
        advocateUpdating: false,
      };
    case "ADD_ADVOCATE_SUCCESS":
      return {
        ...state,
        addAdvocateError: false,
        advocateAddProgress: null,
        advocateAddProgressType: null,
        advocateAdded: true,
        advocateAdding: false,
      };
    case "UPDATE_EVENTS_ERROR":
      return {
        ...state,
        updateAthleteEventsError: "Update Events failed",
        athleteEventsUpdated: false,
      };
    case "UPDATE_EVENTS_SUCCESS":
      return {
        ...state,
        updateAthleteEventsError: null,
        athleteEventsUpdated: true,
      };
    case "CONTACT_REQUEST_ERROR":
      return {
        ...state,
        contactRequestError: "Contact CSA request failed",
        contactRequestSent: false,
      };
    case "CONTACT_REQUEST_SUCCESS":
      return {
        ...state,
        contactRequestError: null,
        contactRequestSent: true,
      };
    case "RESET_CONTACT_REQUEST":
      return {
        ...state,
        contactRequestError: null,
        contactRequestSent: false,
      };
    case "JOIN_CSA_REQUEST_ERROR":
      return {
        ...state,
        joinCsaRequestError: "Join CSA request failed",
        joinCsaRequestSent: false,
      };
    case "JOIN_CSA_REQUEST_SUCCESS":
      return {
        ...state,
        joinCsaRequestError: null,
        joinCsaRequestSent: true,
      };
    case "RESET_JOIN_CSA_REQUEST":
      return {
        ...state,
        joinCsaRequestError: null,
        joinCsaRequestSent: false,
      };
    case "INFO_REQUEST_ERROR":
      return {
        ...state,
        infoRequestError: "Info request failed",
        infoRequestSent: false,
      };
    case "INFO_REQUEST_SUCCESS":
      return {
        ...state,
        infoRequestError: null,
        infoRequestSent: true,
      };
    case "RESET_ATHLETE_REQUEST":
      return {
        ...state,
        infoRequestError: null,
        infoRequestSent: false,
      };
    case "ADD_ATHLETE_ERROR":
      return {
        ...state,
        addAthleteError: "Error adding athlete",
        athleteAdded: false,
      };
    case "ADD_ATHLETE_SUCCESS":
      return {
        ...state,
        addAthleteError: null,
        athleteAdded: true,
      };
    case "ADD_SPORT_SUCCESS":
      return {
        ...state,
        addSportError: null,
        sportAdded: true,
      };
    case "ADD_SPORT_ERROR":
      return {
        ...state,
        addAthleteError: "Error Adding New Sport",
        sportAdded: false,
      };
    case "ADD_POSITION_SUCCESS":
      return {
        ...state,
        addPositionError: null,
        positionAdded: true,
      };
    case "ADD_PLAYERTOWATCH_SUCCESS":
      return {
        ...state,
        addPositionError: null,
        playerToWatchAdded: true,
        playerToWatchProgress: action.value,
        playerToWatchProgressType: action.media,
      };
    case "DELETE_PLAYERTOWATCH_SUCCESS":
      return {
        ...state,
        addPositionError: null,
        playerToWatchDeleted: true,
        playerToWatchProgress: action.value,
        playerToWatchProgressType: action.media,
      };
    case "ADD_POSITION_ERROR":
      return {
        ...state,
        playerToWatchAdded: "Error Adding New Position",
        positionAdded: false,
      };
    case "ADD_PLAYERTOWATCH_ERROR":
      return {
        ...state,
        addPositionError: "Error Adding New Player To Watch",
        positionAdded: false,
      };
    case "EDIT_SCHOOL_ERROR":
      return {
        ...state,
        editSchoolError: "Error editing School",
        schoolEdited: false,
      };
    case "EDIT_SCHOOL_SUCCESS":
      return {
        ...state,
        editSchoolError: null,
        schoolEdited: true,
      };
    case "ADD_SCHOOL_ERROR":
      return {
        ...state,
        addSchoolError: "Error adding School",
        schoolAdded: false,
      };
    case "ADD_SCHOOL_SUCCESS":
      return {
        ...state,
        addSchoolError: null,
        schoolAdded: true,
      };
    case "DELETE_ATHLETE_SUCCESS":
      return {
        ...state,
        deleteAthleteError: null,
        athleteDeleted: true,
      };
    case "DELETE_ATHLETE_ERROR":
      return {
        ...state,
        deleteAthleteError: "Error deleting athlete",
        athleteDeleted: false,
      };
    case "RESET_ATHLETE":
      return {
        updateAthleteError: null,
        athleteUpdated: false,
        athleteUpdateProgress: null,
        athleteUpdateProgressType: null,
        athleteUpdating: false,
        addAthleteError: null,
        athleteAdded: false,
        deleteAthleteError: null,
        athleteDeleted: false,
        updateAthleteEventsError: null,
        athleteEventsUpdated: false,
        addSchoolError: null,
        schoolAdded: false,
        editSchoolError: null,
        schoolEdited: false,
      };
    case "UPDATE_ATHLETE_PROGRESS":
      return {
        ...state,
        athleteUpdateProgress: action.value,
        athleteUpdateProgressType: action.media,
        athleteUpdating: true,
      };
    case "ADD_SKILL_PROGRESS":
      return {
        ...state,
        skillAddProgress: action.value,
        skillAddProgressType: action.media,
        skillAdding: true,
      };
    case "UPDATE_SKILL_PROGRESS":
      return {
        ...state,
        skillUpdateProgress: action.value,
        skillUpdating: true,
      };
    case "ADD_ADVOCATE_PROGRESS":
      return {
        ...state,
        advocateAddProgress: action.value,
        advocateAddProgressType: action.media,
        advocateAdding: true,
      };
    case "UPDATE_ADVOCATE_PROGRESS":
      return {
        ...state,
        advocateUpdateProgress: action.value,
        advocateUpdating: true,
      };
    default:
      return state;
  }
};

export default athleteReducer;
